import { createRequestReducer } from '@fullstory/redux-util';
import { UserDetailsResponse } from '@fullstory/client-api';
import { SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { UserOverlayTypes } from './types';
import { combineReducers } from 'redux';
import { UserOverlayActions } from './actions';
import { EventSearch } from '@fullstory/proto/fs/api/search';

const matchingSessionsOrClips = createRequestReducer<UserDetailsResponse>()(
  UserOverlayTypes.UserDetailsMatchingRequest,
  UserOverlayTypes.UserDetailsMatchingSuccess,
  UserOverlayTypes.UserDetailsMatchingFailure,
);

const allSessions = createRequestReducer<UserDetailsResponse>()(
  UserOverlayTypes.UserDetailsAllSessionsRequest,
  UserOverlayTypes.UserDetailsAllSessionsSuccess,
  UserOverlayTypes.UserDetailsAllSessionsFailure,
);

function segmentDefinition(
  state: SegmentDefinition | null = null,
  action: UserOverlayActions,
): SegmentDefinition | null {
  switch (action.type) {
    case UserOverlayTypes.SetSegmentDefinition: {
      return action.segmentDefinition;
    }
  }
  return state;
}

function eventSearch(
  state: EventSearch | null = null,
  action: UserOverlayActions,
): EventSearch | null {
  switch (action.type) {
    case UserOverlayTypes.SetSegmentDefinition: {
      return action.eventSearch ?? null;
    }
  }
  return state;
}

type UserOverlayReducerState = {
  matchingSessionsOrClips: ReturnType<typeof matchingSessionsOrClips>;
  allSessions: ReturnType<typeof allSessions>;
  segmentDefinition: SegmentDefinition | null;
  eventSearch: EventSearch | null;
};

export const userOverlayReducer = combineReducers<UserOverlayReducerState>({
  matchingSessionsOrClips,
  allSessions,
  segmentDefinition,
  eventSearch,
});
